import { INewBuilding } from '../../types/newBuldings';
import { TViewMode } from '../Projects/types';

export const countOfNewBuildingsMapper: Record<TViewMode, number> = {
  table: 6,
  list: 3,
};

interface IGetNewBuildingsForRenderAttributes {
  newBuildings: INewBuilding[];
  show: boolean;
  mode: TViewMode;
}

export function getNewBuildingsForRender({ newBuildings, show, mode }: IGetNewBuildingsForRenderAttributes): {
  newBuildingsForRender: INewBuilding[];
  hasMore: boolean;
} {
  const count = countOfNewBuildingsMapper[mode];
  const newBuildingsForRender = show ? newBuildings : newBuildings.slice(0, count);
  const hasMore = !show && newBuildings.length > count;

  return { newBuildingsForRender, hasMore };
}
